<template>
    <v-tooltip :value="tooltipVisible" bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-autocomplete 
                v-model="selectedStore" 
                :items="stores" 
                @change="onChange" 
                item-text="name" 
                item-value="id" 
                label="Loja" 
                return-object="true" 
                :disabled="!canSelect"
                :loading="!loaded" 
                clearable 
                v-bind="attrs" 
                v-on="on">
                <template slot="selection" slot-scope="data"> {{ data.item.name }} - {{ data.item.city }} </template>
                <template slot="item" slot-scope="data"> {{ data.item.name }} - {{ data.item.city }} </template>
            </v-autocomplete>
        </template>
        <span>Selecione uma loja</span>
    </v-tooltip>
</template>

<script>
export default {
    data() {
        return {
            stores: [],
            selectedStore: null,
            loaded: false,
            canSelect: false,
            tooltipVisible: false, // Controla a visibilidade do tooltip
        };
    },

    created() {
        this.$http
            .get("stores/ByUser")
            .then((result) => {
                this.stores = result;
                if (this.stores.length > 1) {
                    this.canSelect = true;
                } else if (this.stores.length == 1) {
                    this.selectedStore = this.stores[0];
                    this.onChange();
                }
                this.loaded = true;
            }).catch(() => {
                this.stores = [];
            });
    },

    computed: {
        showError() {
            return this.canSelect && !this.selectedStore;
        },
    },

    watch: {
        showError(newValue) {
            // Atualiza a visibilidade do tooltip com base no estado de erro
            this.tooltipVisible = newValue;
        }
    },

    methods: {
        onChange() {
            this.$emit("onChange", this.selectedStore);
        },
    }
};
</script>